var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "purchase-page" },
    [
      _vm.$route.query.isApp != 1
        ? _c("div", { staticClass: "app-down flex-between" }, [
            _c("div", { staticClass: "flex-center" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/images/logo_download.svg"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "download-content" }, [
                _c("p", [_vm._v("SuperEx APP")]),
                _vm._v(" "),
                _c("span", { staticClass: "block" }, [
                  _vm._v(_vm._s(_vm.$t("300261")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-center" }, [
              _c(
                "dl",
                {
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/download",
                        query: { type: "purchase" }
                      })
                    }
                  }
                },
                [
                  _c("dt", [
                    _c("svg", [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-xiazaitubiao1" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.$t("300345")))])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.query.isApp != 1 ? _c("headerTop") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "purchase-body" },
        [
          _c(
            "van-skeleton",
            {
              staticClass: "swiperSkeleton",
              attrs: { row: 1, loading: _vm.loading }
            },
            [
              _vm.swipeConfig.length > 0
                ? _c(
                    "div",
                    { staticClass: "swiper-banner" },
                    [
                      _c(
                        "van-swipe",
                        { attrs: { autoplay: 3000 } },
                        _vm._l(_vm.swipeConfig, function(image) {
                          return _c(
                            "van-swipe-item",
                            {
                              key: image.id,
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$router.push({
                                    path: image.link,
                                    query: {
                                      banner: true,
                                      isApp: _vm.$route.query.isApp
                                    }
                                  })
                                }
                              }
                            },
                            [_c("img", { attrs: { src: image.image } })]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "winners" }, [
            _c("div", { staticClass: "nav-bar" }, [
              _c("span", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("300299")))
              ]),
              _vm._v(" "),
              _c("span", { on: { click: _vm.lookHistory } }, [
                _vm._v(_vm._s(_vm.$t("300298")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "notice" },
              [
                _c(
                  "van-skeleton",
                  {
                    staticClass: "lamp1Skeleton",
                    attrs: { row: 1, loading: _vm.loading1 }
                  },
                  [
                    _vm.prizeUser.length > 0
                      ? _c(
                          "div",
                          { staticClass: "notice-lamp1" },
                          [
                            _c("horse-lamps", { attrs: { speed: "50" } }, [
                              _c(
                                "ul",
                                { staticClass: "trotting-horse-lamp1 ul50" },
                                _vm._l(_vm.prizeUser, function(item, index) {
                                  return _c("li", { key: index }, [
                                    _c("img", {
                                      class: {
                                        mirrorRotateLevel: _vm.isDirection
                                      },
                                      attrs: {
                                        src: require("../../../static/images/congratulations.png"),
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.message) +
                                        "\n                "
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-skeleton",
                  {
                    staticClass: "lamp2Skeleton",
                    attrs: { row: 1, loading: _vm.loading2 }
                  },
                  [
                    _vm.joinUser.length > 0
                      ? _c(
                          "div",
                          { staticClass: "notice-lamp2" },
                          [
                            _c("horse-lamps", { attrs: { speed: "80" } }, [
                              _c(
                                "ul",
                                { staticClass: "trotting-horse-lamp2 ul80" },
                                _vm._l(_vm.joinUser, function(item, index) {
                                  return _c("li", { key: index }, [
                                    _c("img", {
                                      class: {
                                        mirrorRotateLevel: _vm.isDirection
                                      },
                                      attrs: {
                                        src: require("../../../static/images/congratulations.png"),
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.message) +
                                        "\n                "
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.buySuccess
            ? _c(
                "div",
                { staticClass: "purchase-toast" },
                [
                  _c("lottie", {
                    staticClass: "lottie",
                    attrs: {
                      options:
                        _vm.shopMessage.status == 1 && _vm.num == 1
                          ? _vm.defaultOptions
                          : _vm.towOptions
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.tipMessage))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "van-skeleton",
            {
              staticClass: "productListSkeleton",
              attrs: { row: 1, loading: _vm.loading3 }
            },
            [
              _c(
                "div",
                {
                  directives: [{ name: "masonry", rawName: "v-masonry" }],
                  staticClass: "product-list",
                  attrs: { "transition-duration": "0s" }
                },
                _vm._l(_vm.shopList, function(item) {
                  return _c(
                    "div",
                    {
                      directives: [
                        { name: "masonry-tile", rawName: "v-masonry-tile" }
                      ],
                      key: item.id,
                      staticClass: "product-outbox",
                      class: "demo-" + item.id,
                      attrs: { gutter: "20" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "product-item",
                          on: {
                            click: function($event) {
                              return _vm.goDetail(item)
                            }
                          }
                        },
                        [
                          _c("img", { attrs: { src: item.img, alt: "" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "shop-describe" },
                            [
                              _c("p", { staticClass: "product-title bold" }, [
                                _vm._v(_vm._s(item.title))
                              ]),
                              _vm._v(" "),
                              item.sellCount
                                ? _c("div", { staticClass: "progress-bar" }, [
                                    _c("div", {
                                      staticClass: "rate-of-progress",
                                      style: {
                                        width:
                                          (item.sellCount /
                                            (item.price / item.minPrice)) *
                                            100 +
                                          "%"
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !item.sellCount
                                ? _c("div", { staticClass: "progress-bar" }, [
                                    _c("div", {
                                      staticClass: "rate-of-progress"
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "current-price bold" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("300334")) +
                                    " \n              "
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.minPrice) +
                                      _vm._s(item.currency.toUpperCase())
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "old-price" }, [
                                _vm._v(
                                  _vm._s(item.price) +
                                    _vm._s(item.currency.toUpperCase())
                                )
                              ]),
                              _vm._v(" "),
                              item.status === 1
                                ? _c(
                                    "van-button",
                                    {
                                      staticClass: "bold",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handler(item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("300302")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status === 2
                                ? _c(
                                    "van-button",
                                    {
                                      staticClass: "bold alignBtn",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handler(item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("300303")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShow,
                    expression: "isShow"
                  }
                ],
                staticClass: "loading-box"
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "form-popup",
          attrs: { "close-on-click-overlay": false, position: "bottom" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("p", { staticClass: "Copies flex-between" }, [
            _c("span", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm.$t("300304")))
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "iconfont icon-guanbi1",
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "price",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("300305", {
                  minPrice: _vm.shopMessage.minPrice,
                  currency: _vm.shopMessage.currency.toUpperCase(),
                  maxBuyCount: _vm.shopMessage.maxBuyCount
                })
              )
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "inputBox" }, [
            _c(
              "span",
              {
                staticClass: "subtract bold inline-block",
                class: { disable: _vm.num <= 1 },
                on: { click: _vm.subtractNum }
              },
              [_vm._v("—")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("p", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.num,
                      expression: "num"
                    }
                  ],
                  attrs: { maxlength: "4", type: "text" },
                  domProps: { value: _vm.num },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.num = $event.target.value
                      },
                      _vm.handleInput
                    ]
                  }
                }),
                _vm._v(
                  "\n            " + _vm._s(_vm.$t("300306")) + "\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("300318", {
                      num: _vm.fixedNum(_vm.shopMessage.minPrice, _vm.num),
                      currency: _vm.shopMessage.currency.toUpperCase()
                    })
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "add bold inline-block",
                on: { click: _vm.addNum }
              },
              [_vm._v("+")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "prizeDescribe" }, [
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t("300307", {
                    num: _vm.assetsNum,
                    currency: _vm.shopMessage.currency.toUpperCase()
                  })
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buy" },
            [
              _c(
                "van-button",
                {
                  staticClass: "bold",
                  attrs: {
                    disabled: _vm.num == "" || _vm.num == 0,
                    type: "default"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.buyShop(_vm.shopMessage.id)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300308")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.tipModel,
            callback: function($$v) {
              _vm.tipModel = $$v
            },
            expression: "tipModel"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "describe bold inline-block" }, [
            _vm._v(_vm._s(_vm.tipMessage))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.tipModel = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300309")))]
              ),
              _vm._v(" "),
              _c("van-button", { on: { click: _vm.rechargeBalance } }, [
                _vm._v(_vm._s(_vm.$t("300297")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "prizeModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.prizeModel,
            callback: function($$v) {
              _vm.prizeModel = $$v
            },
            expression: "prizeModel"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("img", {
              staticClass: "mirrorRotateLevel",
              attrs: {
                src: require("../../../static/images/congratulations.png"),
                alt: ""
              }
            }),
            _vm._v("\n\n        " + _vm._s(_vm.$t("300310")) + "\n       "),
            _c("img", {
              attrs: {
                src: require("../../../static/images/congratulations.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "shopName bold" }, [
            _vm._v(_vm._s(_vm.prizeMessage.snapshotTitle))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "prizeImage" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/images/prize.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _vm.$route.query.isApp == 1
            ? _c(
                "div",
                { staticClass: "btn inline-block" },
                [
                  _c(
                    "van-button",
                    { staticClass: "bold", on: { click: _vm.showOff } },
                    [_vm._v(_vm._s(_vm.$t("300346")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tipsMessage" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t("300349")) + " ")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("300350")))])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.query.isApp != 1
            ? _c("div", { staticClass: "tipsMessage" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("300349")) + " ")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("300350")))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "close" }, [
            _c("svg", { on: { click: _vm.closePrize } }, [
              _c("use", { attrs: { "xlink:href": "#icon-guanbi2" } })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("tips-model", {
        attrs: {
          show: _vm.tipsdialog,
          content: _vm.tipMessage,
          colseFun: _vm.closeTips
        }
      }),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.selled,
            callback: function($$v) {
              _vm.selled = $$v
            },
            expression: "selled"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "describe bold inline-block" }, [
            _vm._v(_vm._s(_vm.tipMessage))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.selled = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300312")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.rechargeModel,
            callback: function($$v) {
              _vm.rechargeModel = $$v
            },
            expression: "rechargeModel"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "recharge inline-block" }, [
            _vm._v(_vm._s(_vm.$t("300313")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.rechargeModel = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300286")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.getPrize,
            callback: function($$v) {
              _vm.getPrize = $$v
            },
            expression: "getPrize"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "recharge inline-block" }, [
            _vm._v(_vm._s(_vm.$t("300315")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell inline-block" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      _vm.getPrize = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300286")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f38cb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f38cb6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/purchase/index.vue
// module id = +Rh/
// module chunks = 0